import styled from 'styled-components';

export const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 330px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 6px 0px lightgrey;
  border-radius: 40px;
  border: 0px;
  outline: 0;
  padding: 0px 10px;
  margin: 20px 0px;
  font-family: 'FontsFreeNetSFProTextMedium';
  font-size: 1.4rem;
  color: #21E270;
  cursor: pointer;

  > a {
    color: inherit;
  }

  @media (max-width: 380px) {
   width: 100%;
  }
`;

export const IconLeft = styled.img`
  height: 16px;
  margin-right: 4px;
`;
